import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { accountsEditService } from '../services/accountsEdit.service';

export function useAccountsEdit() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id') || '';
  const queryClient = useQueryClient();
  
  const [formData, setFormData] = useState({
    accountName: '',
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    accountHolder: '',
    currency: 'VND',
    initialBalance: 0,
    status: 'active' as any,
    isDefault: false,
    description: '',
  });

  const query = useQuery({
    queryKey: ['settings', 'accounts', 'detail', id],
    queryFn: () => accountsEditService.getAccount(id),
    enabled: !!id,
  });

  useEffect(() => {
    if (query.data) {
      setFormData({
        accountName: query.data.accountName,
        accountNumber: query.data.accountNumber,
        bankName: query.data.bankName,
        bankBranch: query.data.bankBranch || '',
        accountHolder: query.data.accountHolder,
        currency: query.data.currency,
        initialBalance: query.data.initialBalance,
        status: query.data.status,
        isDefault: query.data.isDefault,
        description: query.data.description || '',
      });
    }
  }, [query.data]);

  const mutation = useMutation({
    mutationFn: (data: any) => accountsEditService.updateAccount(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'accounts'] });
      toast.success('Đã cập nhật tài khoản');
      navigate('?tab=account');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Không thể cập nhật tài khoản');
    }
  });

  return {
    formData,
    setFormData,
    isLoading: query.isLoading,
    isSaving: mutation.isPending,
    updateAccount: () => mutation.mutate(formData),
  };
}
